import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/lang'

import HomeView from '../views/Home/index.vue'
import LoginView from '../views/Login/index.vue'
import RegisterView from '../views/Register/index.vue'
import FindPwd from '../views/FindPwd/index.vue'
import ExchangeView from '../views/Exchange/index.vue'
import TradeView from '../views/Trade/index.vue'
import TradeList from '../views/TradeLst/index.vue'
import OptionsView from '../views/Kline/index.vue'

import RealAuthentication from '../views/RealAuthentication/index.vue'
import MentionAddress from '../views/MentionAddress/index.vue'
import SecurityView from '../views/Security/index.vue'
import ResetLegalPwd from '../views/Security/ResetLegalPwd.vue'
import ModifyPwd from '../views/Security/ModifyPwd.vue'
import MyInvite from '../views/MyInvite/index.vue'
import MyNotify from '../views/MyNotify/index.vue'
import UsrBank from '../views/Bank/index.vue'
import AssetsView from '../views/Assets/index.vue'
import TradeAccount from '../views/TradeAccount/index.vue'

import ChangeMoney from '../views/ChangeMoney/index.vue'
import RechargeView from '../views/Recharge/index.vue'
import WithdrawalView from '../views/UsrWithdrawal/index.vue'
import LockmingView from '../views/lockming/index.vue'
import LockmingApplication from '../views/lockming/lockming.vue'

import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      requireAuth: false,
      title: i18n.t('footer.home'),
    }
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: {
      requireAuth: false,
      title: i18n.t('footer.home'),
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      title: i18n.t('register.login'),
      requireAuth: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: {
      title: i18n.t('register.register'),
      requireAuth: false
    }
  },
  {
    path: '/findpwd',
    name: 'findpwd',
    component: FindPwd,
    meta: {
      title: i18n.t('register.fotget'),
      requireAuth: false
    }
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: ExchangeView,
    meta: {
      title: i18n.t('trade.title'),
      requireAuth: false
    }
  },
  {
    path: '/trade',
    name: 'trade',
    component: TradeView,
    meta: {
      title: i18n.t('option.typetitle'),
      requireAuth: false
    }
  },
  {
    path: '/trade-lst',
    name: 'trade-lst',
    component:TradeList,
    meta: {
      title: i18n.t('tradelst.title'),
      requireAuth: true
    }
  },
  {
    path: '/options',
    name: 'options',
    component: OptionsView,
    meta: {
      title: i18n.t('trade.title'),
      requireAuth: false
    }
  },
  {
    path: '/real_authentication',
    name: 'real_authentication',
    component:RealAuthentication,
    meta: {
      title: i18n.t('identity.title'),
      requireAuth: true
    }
  },
  {
    path: '/bindMentionAddress',
    name: 'bindMentionAddress',
    component:MentionAddress,
    meta: {
      title: i18n.t('address.title'),
      requireAuth: true
    }
  },
  {
    path: '/security',
    name: 'security',
    component:SecurityView,
    meta: {
      title: i18n.t('security.title'),
      requireAuth: true
    }
  },
  {
    path: '/modifyPwd',
    name: 'modifyPwd',
    component:ModifyPwd,
    meta: {
      title: i18n.t('security.modifypwd'),
      requireAuth: true
    }
  },
  {
    path: '/resetLegalPwd',
    name: 'resetLegalPwd',
    component:ResetLegalPwd,
    meta: {
      title: i18n.t('security.resetlegalpwd'),
      requireAuth: true
    }
  },
   {
    path: '/bank',
    name: 'bank',
    component:UsrBank,
    meta: {
      title: i18n.t('bank.title'),
      requireAuth: true
    }
  },
  {
    path: '/invite',
    name: 'invite',
    component:MyInvite,
    meta: {
      title: i18n.t('member.my_promotion_code'),
      requireAuth: true
    }
  },
  {
    path: '/notify',
    name: 'notify',
    component:MyNotify,
    meta: {
      title: i18n.t('member.system_message'),
      requireAuth: true
    }
  },
  {
    path: '/assets',
    name: 'assets',
    component:AssetsView,
    meta: {
      title: i18n.t('footer.assets'),
      requireAuth: true
    }
  },
  {
    path: '/trade-account',
    name: 'trade-account',
    component:TradeAccount,
    meta: {
      title: i18n.t('footer.assets'),
      requireAuth: true
    }
  },
   {
    path: '/changemoney',
    name: 'changemoney',
    component:ChangeMoney,
    meta: {
      title: i18n.t('change.title'),
      requireAuth: true
    }
  },
  {
    path: '/recharge',
    name: 'recharge',
    component:RechargeView,
    meta: {
      title: i18n.t('recharge.title'),
      requireAuth: true
    }
  },
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component:WithdrawalView,
    meta: {
      title: i18n.t('withdrawal.title'),
      requireAuth: true
    }
  },
  {
    path: '/lockming',
    name: 'lockming',
    component:LockmingView,
    meta: {
      title: i18n.t('lockming.title'),
      requireAuth: true
    }
  },
  {
    path: '/lockming-application',
    name: 'lockming-application',
    component:LockmingApplication,
    meta: {
      title: i18n.t('lockming.tolockming'),
      requireAuth: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // 核心配置：返回顶部坐标
    return new Promise((resolve) => {
      // 支持异步滚动 (如数据加载完成后)
      setTimeout(() => {
        resolve({ x: 0, y: 0, behavior: 'instant' })
      }, 50)
    })
  }
})

router.beforeEach((to, from, next) => {
  const nearestTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta?.title);
    let webName = ''
    if(store.state && store.state.sysconfig && store.state.sysconfig.config && store.state.sysconfig.config.name){
      webName = store.state.sysconfig.config.name + '- '
    }
  if (to.params.id && nearestTitle) {
    document.title = webName + `${nearestTitle.meta.title} `;
  } else {
    document.title = webName + nearestTitle?.meta.title || '';
  }
  
  next();
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
